<!-- <p>address-add works!</p> -->
<div class="add_address_cont">
	<h3 class="add_address_heading">
		{{addressTypeData.type === 'add' ? 'Add new' : 'Edit'}} {{addressTypeData.isBilling ? 'Billing' : 'Shipping'}}
		address
	</h3>

	<form class="form_cont_outer" *ngIf="addressFromData" [formGroup]="addressFromData">
		<div class="form_wrapper craft_wrapper ">
			<div *ngIf="showCountryCodeError()"
				 class="form_cont full bg-red-100 rounded my-2 px-2 py-1">
				<div class="error_input_relative flex items-center gap-2">
					<span class="material-symbols-outlined">error</span>
					<p>Please update the country code for your <strong class=font-bold>primary phone number</strong></p>
				</div>
			</div>
			<div class="form_cont full">
				<input type="text" placeholder="Name*" formControlName="name" required>
				<ng-container
					*ngIf="addressFromData.controls['name'].invalid && addressFromData.controls['name'].touched">
					<p class="error_input" *ngIf="addressFromData.controls['name'].hasError('required')">Name is
						required.
					</p>
				</ng-container>
			</div>

			<div class="form_cont full">
				<select formControlName="country">
					<option value="" class="defalut_option">Country*</option>
					<option [value]="country.name" *ngFor="let country of countryList">{{country.name}}</option>
				</select>
				<ng-container
					*ngIf="addressFromData.controls['country'].invalid && addressFromData.controls['country'].touched">
					<p class="error_input" *ngIf="addressFromData.controls['country'].hasError('required')">Country is
						required.
					</p>
				</ng-container>
			</div>

			<div class="form_cont half">
				<input type="text" placeholder="State*" formControlName="state" required>
				<ng-container
					*ngIf="addressFromData.controls['state'].invalid && addressFromData.controls['state'].touched">
					<p class="error_input" *ngIf="addressFromData.controls['state'].hasError('required')">state is
						required.
					</p>
				</ng-container>
			</div>

			<div class="form_cont half">
				<input type="text" placeholder="City*" formControlName="city" required>
				<ng-container
					*ngIf="addressFromData.controls['city'].invalid && addressFromData.controls['city'].touched">
					<p class="error_input" *ngIf="addressFromData.controls['city'].hasError('required')">city is
						required.
					</p>
				</ng-container>
			</div>

			<div class="form_cont full">
				<input type="text" placeholder="Address Line 1*" formControlName="addressLineOne" required>
				<ng-container
					*ngIf="addressFromData.controls['addressLineOne'].invalid && addressFromData.controls['addressLineOne'].touched">
					<p class="error_input" *ngIf="addressFromData.controls['addressLineOne'].hasError('required')">
						addressLine 1 is
						required.
					</p>
				</ng-container>
			</div>
			<div class="form_cont full">
				<input type="text" placeholder="Address Line 2" formControlName="addressLineTwo">
			</div>

			<div class="form_cont half">
				<input type="text" required placeholder="Postal Code*" formControlName="postalCode"
					oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
					maxlength="7">
				<ng-container
					*ngIf="addressFromData.controls['postalCode'].invalid && addressFromData.controls['postalCode'].touched">
					<p class="error_input" *ngIf="addressFromData.controls['postalCode'].hasError('required')">Postal
						code
						is
						required.
					</p>
				</ng-container>
			</div>

			<div class="form_cont half">
				<input type="text" placeholder="Company Name" formControlName="companyName">
			</div>

			<div class="form_cont half">
				<ngx-intl-tel-input
					[cssClass]="'custom-input-half'"
					[preferredCountries]="preferredCountries"
					[enableAutoCountrySelect]="true"
					[enablePlaceholder]="true"
					[searchCountryFlag]="true"
					[searchCountryField]="[ SearchCountryField.Iso2, SearchCountryField.Name]"
					[selectFirstCountry]="false"
					[phoneValidation]="true"
					[separateDialCode]="true"
					[selectedCountryISO]="defaultCountry"
					[numberFormat]="PhoneNumberFormat.International"
					name="primaryPhone"
					formControlName="primaryPhone"
				>
				</ngx-intl-tel-input>
				<ng-container
					*ngIf="addressFromData.controls['primaryPhone'].invalid && addressFromData.controls['primaryPhone'].touched">
					<p class="error_input">
						A valid phone number is required with the country code.
					</p>
				</ng-container>
				<ng-container
					*ngIf="showCountryCodeError() && !addressFromData.controls['primaryPhone'].touched">
					<p class="warning_input top-12">
						Review country code and phone number. <strong class="font-bold">Update</strong> to proceed.
					</p>
				</ng-container>
			</div>

			<div class="form_cont half ">
				<input class="secondary_phone_input" type="tel" placeholder="Secondary Phone" formControlName="secondaryPhone">
			</div>

			<div class="form_cont">
				<input type="email" placeholder="Email*" formControlName="contactEmail">
				<ng-container
					*ngIf="addressFromData.controls['contactEmail'].invalid && (addressFromData.controls['contactEmail'].dirty || addressFromData.controls['contactEmail'].touched)">
					<p class="error_input" *ngIf="addressFromData.controls['contactEmail'].hasError('required')">Email
						is
						required
					</p>
					<p class="error_input" *ngIf="addressFromData.controls['contactEmail'].hasError('email')">
						Invalid email format.</p>
				</ng-container>
			</div>

			<div class="form_cont full">
				<input type="text" placeholder="VAT/GST No." formControlName="vatgstNumber">
			</div>

			<div class="form_cont full">
				<input type="text" placeholder="EORI Number - Must for custom clearance if applicable"
					formControlName="eoriNumber">
			</div>

		</div>
		<button (click)="submitAddressFromData()">
			{{addressTypeData.type === 'add' ? 'Save' : 'Update'}}
			{{addressTypeData.isBilling ? 'Billing' : 'Shipping'}}
			Address
		</button>
	</form>


</div>
